
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './MOZ_EvCastList.html?raw';
import '../../../moreCore/UI/Edit/Edit';
import '../../../moreCore/UI/CheckBox/CheckBox';
import HintBox from '../../../moreCore/UI/EntityBased/HintBox/HintBox';
import '../../../moreCore/UI/EntityBased/HintBox/HintBox';
import "../../../moreCore/UI/SearchSelect/SearchSelect";
import "../../../moreCore/UI/_StatefulBase/_StatefulBase";
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
//import { EvCastList } from "../../_loadingHelpers/VAMv2";
import EvCastList from '../EvCast/EvCastList';

import { VAM2types, VAMclassNames } from "../../_loadingHelpers/VAMv2Types";


interface Professor extends more.EntityAPIResult {
    gDisp_1?: string;
}

interface MozEvCast extends VAM2types.EvCast {
    ref_teaching_professor: Professor;
}

class MOZ_EvCastList extends compose(EvCastList) {
    templateString: any = template;

    addEntryButton: HTMLButtonElement;
    professorInput: MdsLax<InstanceType<typeof HintBox>>;
 
    protected castTableLayout: StaticTable.RowConfig = {
        colNamesInternal: ["c_cast_address", "c_cast_perfomer", "ref_teaching_professor.gDisp_1"],
        "attributes": ["c_cast_address", "c_cast_perfomer", "ref_teaching_professor.gDisp_1"],
        "colspans": [1, 1, 1],
        "headings": [(this as any).translations["BookingEditor__castAddressTableHeader"], (this as any).translations["BookingEditor__castRoleTableHeader"], (this as any).translations["BookingEditor__castProfessorTableHeader"]],
        widths: [null, null, null/*, "15ch"*/],
        alignmentsHeading: [null, null, null/*, "right"*/],
        alignmentsRow: [null, null, null/*, "right"*/]
    }

    protected _onChangePerformerInput(): void {
        let performerData = this.performerInput.getValue() as MozEvCast;
        let readyCheck = performerData != null && this.professorInput.getValue() != null;

        this.UiModder.domClass.toggle(this.addEntryButton, "w3-disabled", !readyCheck);

        if (performerData.ref_teaching_professor != null) {
            this.professorInput.setValue(performerData.ref_teaching_professor);
        }
    }


    protected _onClickAddEntryButton(): void {

        let value = this.performerInput.getValue() as VAM2types.Performer;
        let value_teacher = this.professorInput.getValue() as Professor;

        if (value != null) {
            let fakeCast: MozEvCast = {
                ID: (Math.random() * 100000).toString(),
                Classname: "ev_cast",
                c_cast_address: value.ref_address.pseudonym,
                c_cast_perfomer: value.ref_ev_profession.description,
                ref_performer: value,
                ref_teaching_professor: value_teacher,
                $Displayname: value.ref_address.pseudonym,
                order: 0
            }

            //this.store.reset();
            this.store.addEntry(fakeCast);

            this.performerInput.setValue(null, true);
            this.UiModder.domClass.add(this.addEntryButton, "w3-disabled");
        }
    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.professorInput.enableSelectEntityDialog(true);
        this.store.reset();
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(MOZ_EvCastList);

//